export { default } from "./useDistrictBulkProcessingConfigGet";
